import styled from "styled-components";
import { colors } from "../../../styles/variables";

export const StyledCopyright = styled.div`
  font-size: 12px;
  line-height: 20px;
  padding: 10px 0;
  display: inline-block;
  text-align: center;
  width: 100%;
  background-color: ${({ theme }) =>
    theme.footer?.copyright?.backgroundColor || colors.white};
  color: ${({ theme }) => theme.footer?.copyright?.textColor || colors.gray600};
`;
